import clsx from 'clsx'
import { Fragment, type HTMLAttributes } from 'react'

import styles from './Stepper.module.scss'

type StepperProps = HTMLAttributes<HTMLElement> & {
  children: React.ReactNode
  className?: string
}

const Stepper = (props: StepperProps) => {
  const { children, className, ...rest } = props
  return (
    <nav {...rest}>
      <ol className={clsx(styles.stepper, className)}>{children}</ol>
    </nav>
  )
}

Stepper.displayName = 'Stepper'

type StepperStepProps = HTMLAttributes<HTMLLIElement> & {
  icon?: React.ReactNode
  label: string
  number: number
  disabled?: boolean
  className?: string
}

const StepperLabel = ({ label }: { label: string }) => {
  const labelWords = label.split(' ')

  if (labelWords.length === 1) {
    return <span className={styles.label}>{label}</span>
  }

  return (
    <span className={styles.label}>
      {labelWords.map((word, index) => (
        <Fragment key={index}>
          {word}
          {index < labelWords.length - 1 && <br />}
        </Fragment>
      ))}
    </span>
  )
}

const StepperStep = (props: StepperStepProps) => {
  const { icon, label, number, disabled, className, ...rest } = props

  return (
    <li
      {...rest}
      className={clsx(
        styles.step,
        styles.default,
        disabled && styles.disabled,
        className
      )}
    >
      <div className={styles.content}>
        <div className={styles.stepText}>
          <span className={styles.number}>{number}</span>
          <StepperLabel label={label} />
        </div>
        {icon ? <div className={styles.icon}>{icon}</div> : null}
      </div>
    </li>
  )
}

StepperStep.displayName = 'StepperStep'
Stepper.Step = StepperStep

export default Stepper
